import { Component } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-nav-bar',
    imports: [RippleModule, SidebarModule, SideBarComponent],
    templateUrl: './nav-bar.component.html',
    styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent {
    constructor(private router: Router) {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntilDestroyed(),
                tap((routerEvent) => {
                    if (routerEvent instanceof NavigationEnd && this.isMobileView) {
                        this.sidebarVisible = false;
                    }
                }),
            )
            .subscribe();
    }

    get isMobileView(): boolean {
        return window.innerWidth < 767;
    }
    sidebarVisible: boolean = false;

    toggleSideBar() {
        this.sidebarVisible = !this.sidebarVisible;
    }
}
